import { render, staticRenderFns } from "./BloqueioConfiguracao.vue?vue&type=template&id=0e893833&scoped=true"
import script from "./BloqueioConfiguracao.vue?vue&type=script&lang=ts"
export * from "./BloqueioConfiguracao.vue?vue&type=script&lang=ts"
import style0 from "./BloqueioConfiguracao.vue?vue&type=style&index=0&id=0e893833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e893833",
  null
  
)

export default component.exports